import React from "react";
import BRAND_IMAGES from "@/lib/brand";

const WhyThisMatters = () => {
  return (
    <section
      className="py-24 md:py-36 bg-alabaster relative overflow-hidden"
      data-testid="why-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-16 md:gap-24 items-center">
        {/* Image side */}
        <div className="fade-up">
          <div
            className="host-image-wrap"
            style={{
              boxShadow: "0 40px 80px -40px rgba(70, 50, 20, 0.3)",
            }}
          >
            <img
              src={BRAND_IMAGES.hostPortraitCloseup}
              alt="A moment of stillness. Aligned, present, at peace."
              className="w-full h-auto block"
              data-testid="why-section-image"
              loading="lazy"
            />
          </div>
        </div>

        {/* Text side */}
        <div className="fade-up delay-200">
          <p className="eyebrow mb-4" data-testid="why-section-overline">
            Why This Matters
          </p>
          <h2
            className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight balance"
            style={{ color: "var(--ink)" }}
            data-testid="why-section-headline"
          >
            What happens when{" "}
            <em
              className="font-light"
              style={{ color: "var(--gold-deep)" }}
            >
              doing more stops working?
            </em>
          </h2>

          <div
            className="mt-8 space-y-5 leading-relaxed text-[color:var(--ink-soft)] pretty"
            style={{ fontSize: "1.15rem" }}
          >
            <p>
              So many women are quietly exhausted. They are achieving,
              striving, holding it all together, and yet a part of them feels
              further from themselves than ever.
            </p>
            <p>
              We have been taught that the path to freedom is paved with more
              effort, more hustle, more doing. But the truth is, the harder we
              push, the more we move away from the very thing we are reaching
              for.
            </p>
            <p
              className="font-serif italic"
              style={{
                color: "var(--ink)",
                fontSize: "1.65rem",
                lineHeight: 1.35,
              }}
            >
              You are not meant to do more. You are meant to be more.
            </p>
            <p
              className="font-serif italic"
              style={{
                color: "var(--gold-deep)",
                fontSize: "1.65rem",
                lineHeight: 1.35,
              }}
            >
              And that changes everything.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyThisMatters;
